import React from "react";
import { filesDelete } from "../../../api/api";
import { generateClassName } from "../../../hooks/useAttributes";
import { useProducts } from "../../../state/api/products/useProducts";
import { useSession } from "../../../state/api/session/useSession";
import { Doc } from "../../../types/db/collections";
import { GetFileResponse } from "../../../types/db/schema/files/file.schema";
import { getDateIn } from "../../../util/time";
import DeleteButton from "../buttons/DeleteButton";
import Pill from "../pill/Pill";
import DownloadFileButton from "./DownloadFileButton";
import FileDialog from "./FileDialog";
import "./FileItem.css";

interface Props {
  file: Doc<GetFileResponse>;
  hasAccess: boolean;
}

export default function FileItem({ file, hasAccess }: Props) {

  const { mutate } = useProducts({ enabled: false });
  const { session } = useSession();

  return (
    <React.Fragment>
      <div className="d-flex flex-row w-100 gap-1">
        <div className={generateClassName("d-flex w-100 gap-2 flex-column", {
          value: !hasAccess,
          onTrue: "file-item-locked"
        })
        } >
          <div className="d-flex flex-row gap-2 w-100 justify-content-between">
            <div className="d-flex w-100 flex-column gap-1">
              <span className="file-title">{file.name}</span>
              <div className="d-flex flex-row gap-2 align-items-center" style={{ height: "fit-content" }}>
                {
                  !hasAccess && (
                    <Pill
                      size="small"
                      background="#fef3c7"
                      foreground="#92400e"
                      border="1px solid #fde68a"
                    >
                      LOCKED
                    </Pill>
                  )
                }
                {
                  !file.isActive && (
                    <Pill background="var(--gray-100)" foreground="var(--gray-600)" >
                      Inactive
                    </Pill>
                  )
                }
                {
                  file.showIsNew && (
                    <Pill>
                      NEW
                    </Pill>
                  )
                }
                <Pill
                  background="var(--gray-100)"
                  foreground="var(--gray-600)"
                  border="1px solid var(--gray-200)"
                >
                  v{file.version || "1"}
                </Pill>

              </div>
            </div>
            <DownloadFileButton
              locked={!hasAccess}
              file={file}
            />
          </div>
          <span className="font-code font-s" style={{ color: "var(--gray-400)" }}>
            {file.description || "File"}
          </span>
        </div>
        {
          session.isAdmin && (
            <div className="d-flex flex-row gap-1">
              <FileDialog file={file} text="" variant="subtle" />
              <DeleteButton
                variant="subtle"
                text=""
                size="small"
                afterDelete={mutate}
                apiCall={async () => filesDelete(file._id)}
              />
            </div>
          )
        }
      </div>
      <div style={{ width: "100%", height: "1px", backgroundColor: "var(--gray-100)" }}  >
      </div>
    </React.Fragment>
  )
}